import React, { Component, useEffect } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { nonEmptyArray, composeValidators } from '../../util/validators';
import { isUploadImageOverLimitError } from '../../util/errors';
import { AddImages, Button, FieldTextInput, Form, ValidationError } from '../../components';
// trying to do the drag and drop
import * as validators from '../../util/validators';

import css from './EditListingPhotosForm.css';
import { Prompt } from 'react-router';
import InvalidImageModal from './InvalidImageModal';
import { Droppable } from 'react-beautiful-dnd';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const ACCEPT_IMAGES = 'image/*';

export class EditListingPhotosFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { imageUploadRequested: false, invalidImage:false, imageWarningText:false};
    this.onImageUploadHandler = this.onImageUploadHandler.bind(this);
    this.submittedImages = [];
  }
  imageValidator(file){

    let reader= new FileReader();
     reader.onload= (e)=>{
      let img = new Image();
      img.src= e.target.result;


      img.onload=()=>{
        let imgWidth= img.width;
        let imgHeight=img.height;
        if(imgWidth>imgHeight)
          {
            this.setState({ imageUploadRequested: true,invalidImage:false, imageWarningText:false });
              this.props
              .onImageUpload({ id: `${file.name}_${Date.now()}`, file })
              .then(() => {
                this.setState({ imageUploadRequested: false });
              })
              .catch(() => {
                this.setState({ imageUploadRequested: false });
              });
          }
          else {
            this.setState({invalidImage:true, imageWarningText:true})

          }

      }
    }
     reader.readAsDataURL(file);

  }
  onImageUploadHandler(file) {
    if(file){
      this.imageValidator(file)
  }
}
handleClose=()=>{
  this.setState({invalidImage:false})
}

render() {
    return (
      <FinalForm
        {...this.props}
        onImageUploadHandler={this.onImageUploadHandler}
        imageUploadRequested={this.state.imageUploadRequested}
        initialValues={{ images: this.props.images}}
        render={formRenderProps => {
          const {
            form,
            className,
            fetchErrors,
            handleSubmit,
            images,
            imageUploadRequested,
            intl,
            invalid,
            onImageUploadHandler,
            onRemoveImage,
            disabled,
            ready,
            saveActionMsg,
            updated,
            updateInProgress,
            pristine,
            doneAndswitch
          } = formRenderProps;


          const chooseImageText = (
            <span className={css.chooseImageText}>
              <span className={css.chooseImage}>
                <FormattedMessage id="EditListingPhotosForm.chooseImage" />
              </span>
              <span className={css.imageTypes}>
                <FormattedMessage id="EditListingPhotosForm.imageTypes" />
              </span>
            </span>
          );

          const imageRequiredMessage = intl.formatMessage({
            id: 'EditListingPhotosForm.imageRequired',
          });

          const { publishListingError, showListingsError, updateListingError, uploadImageError } =
            fetchErrors || {};
          const uploadOverLimit = isUploadImageOverLimitError(uploadImageError);

          let uploadImageFailed = null;

          if (uploadOverLimit) {
            uploadImageFailed = (
              <p className={css.error}>
                <FormattedMessage id="EditListingPhotosForm.imageUploadFailed.uploadOverLimit" />
              </p>
            );
          } else if (uploadImageError) {
            uploadImageFailed = (
              <p className={css.error}>
                <FormattedMessage id="EditListingPhotosForm.imageUploadFailed.uploadFailed" />
              </p>
            );
          }

          // NOTE: These error messages are here since Photos panel is the last visible panel
          // before creating a new listing. If that order is changed, these should be changed too.
          // Create and show listing errors are shown above submit button
          const publishListingFailed = publishListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPhotosForm.publishListingFailed" />
            </p>
          ) : null;
          const showListingFailed = showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPhotosForm.showListingFailed" />
            </p>
          ) : null;

          const submittedOnce = this.submittedImages.length > 0;
          // imgs can contain added images (with temp ids) and submitted images with uniq ids.

          const arrayOfImgIds = imgs =>
            imgs.map(i => (typeof i.id === 'string' ? i.imageId : i.id));
          const imageIdsFromProps = arrayOfImgIds(images);
          const imageIdsFromPreviousSubmit = arrayOfImgIds(this.submittedImages);
          const imageArrayHasSameImages = isEqual(imageIdsFromProps, imageIdsFromPreviousSubmit);
          const pristineSinceLastSubmit = submittedOnce && imageArrayHasSameImages;

          const submitReady = (updated && pristineSinceLastSubmit) || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled =
            invalid || disabled || submitInProgress || imageUploadRequested || ready || this.state.invalidImage;

          const classes = classNames(css.root, className);
          return (
            <div>
            <Form
              className={classes}
              onSubmit={e => {
                this.submittedImages = images;
                handleSubmit(e);
              }}
            >
              <Prompt
                when={!pristine}
                message="You have unsaved changes, are you sure you want to leave?"
              />
              {updateListingError ? (
                <p className={css.error}>
                  <FormattedMessage id="EditListingPhotosForm.updateFailed" />
                </p>
              ) : null}
             {/* <Droppable droppableId='images'>
                {(provided) => (
                    <div  ref={provided.innerRef} {...provided.droppableProps}>*/}
                    <DndProvider backend={HTML5Backend}>
                      <AddImages
                        doneAndSwitch={doneAndswitch}
                        className={css.imagesField}
                        images={images}
                        thumbnailClassName={css.thumbnail}
                        savedImageAltText={intl.formatMessage({
                          id: 'EditListingPhotosForm.savedImageAltText',
                        })}
                        onRemoveImage={onRemoveImage}
                      >
                        <Field
                          id="addImage"
                          name="addImage"
                          accept={ACCEPT_IMAGES}
                          form={null}
                          label={chooseImageText}
                          type="file"
                          disabled={imageUploadRequested}
                        >
                          {fieldprops => {
                            const { accept, input, label, disabled: fieldDisabled } = fieldprops;
                            const { name, type } = input;
                            const onChange = e => {
                              const file = e.target.files[0];
                              form.change(`addImage`, file);
                              form.blur(`addImage`);
                              onImageUploadHandler(file);
                            };
                            const inputProps = { accept, id: name, name, onChange, type };
                            return (
                              <div className={css.addImageWrapper} onClick={()=>this.setState({invalidImage:false})}>
                                <div className={css.aspectRatioWrapper}>
                                  {fieldDisabled ? null : (
                                    <input {...inputProps} className={css.addImageInput} />
                                  )}
                                  <label htmlFor={name} className={css.addImage}>
                                    {label}
                                  </label>
                                </div>
                              </div>
                            );
                          }}
                        </Field>

                        <Field
                          component={props => {
                            const { input, meta } = props;
                            return (
                              <div className={css.imageRequiredWrapper}>
                                <input {...input} />
                                <ValidationError fieldMeta={meta} />
                              </div>
                            );
                          }}
                          name="images"
                          type="hidden"
                          validate={composeValidators(nonEmptyArray(imageRequiredMessage))}
                        />
                          {this.state.imageWarningText?<div className={css.error}>
                            <FormattedMessage id="EditListingPhotosForm.invalidImage"/>
                          </div>
                          :null}
                      </AddImages>
                      </DndProvider>
                    {/*  {provided.placeholder}
                    </div>

                )}
              </Droppable>
              */}
              {uploadImageFailed}

                {/*  displaying uploaded image to get dimensions */}



              <div className={css.tip}>
                <p>
                  <FormattedMessage id="EditListingPhotosForm.addImagesTip" />
                </p>
              </div>
              {publishListingFailed}
              {showListingFailed}

              <Button
                className={css.submitButton}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
              >
                {saveActionMsg}
              </Button>

                 <InvalidImageModal
                    intl={intl}
                    showModal={this.state.invalidImage}
                    handleClose={this.handleClose}
                    />
            </Form>

            </div>
          );
        }}
      />
    );
  }
}

EditListingPhotosFormComponent.defaultProps = { fetchErrors: null, images: [] };

EditListingPhotosFormComponent.propTypes = {
  fetchErrors: shape({
    publishListingError: propTypes.error,
    showListingsError: propTypes.error,
    uploadImageError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  images: array,
  intl: intlShape.isRequired,
  onImageUpload: func.isRequired,
  onUpdateImageOrder: func.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  onRemoveImage: func.isRequired,
};

export default compose(injectIntl)(EditListingPhotosFormComponent);
